/** @jsx jsx */
import { FileEntryFile, FileEntryMode } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { PreviewFileEntry } from "@/components/Files/preview/PreviewFileEntry";
import { FileUploadStateItem } from "@/components/Files/upload/fileUploadReducer";
import { InProgressFileEntry } from "@/components/Files/upload/InProgressFileEntry";
import { Attachment } from "@/data/attachments";
import { useAttachmentMetaByIdQuery } from "@/data/attachments/queries/useAttachmentMetaByIdQuery";
import { useFormats } from "@/hooks/Formats";

interface ApplyFileEntryProps {
  item: FileUploadStateItem<Attachment>;
  deleteFileEntry: (file: FileEntryFile) => void;
  maxSize: number;
}

export const ApplyFileEntry: FC<ApplyFileEntryProps> = ({ item, deleteFileEntry, maxSize }) => {
  const { t } = useTranslation(["public", "common", "session"]);
  const { formatDate } = useFormats();

  const parentAttachmentQuery = useAttachmentMetaByIdQuery(item.attachment?.parentId);

  if (!item.attachment) {
    return (
      <InProgressFileEntry
        attachment={item.file!}
        error={item.error && t(`common:VALIDATION_MESSAGES.${item.error}`, { size: maxSize })}
        progress={item.progress}
        onCancel={deleteFileEntry}
        onRemove={deleteFileEntry}
      />
    );
  }

  return (
    <PreviewFileEntry
      attachment={item.attachment!}
      mode={FileEntryMode.EDIT}
      onRemove={deleteFileEntry}
      subtitle={
        item.attachment?.parentId
          ? parentAttachmentQuery.data
            ? formatDate(parentAttachmentQuery.data.createdDate)
            : t("session:JOB_REQUESTS.APPLY.WIZARD.EXISTING")
          : item.attachment
          ? t("session:JOB_REQUESTS.APPLY.WIZARD.NEW")
          : undefined
      }
    />
  );
};
